module.exports = __webpack_public_path__ + "img/nogroup.ed84f951.svg";